export default {
  en: {
    SubscriptionSuccessTitle: 'Thank you!',
    SubscriptionSuccessParagraph:
      'We guide companies into an AI-fueled future<br/>by building Modern Data Systems.<br/><br/>Enjoy our newsletter!<br/>Keep up with the latest industry trends,<br/>events, and Mutt Data updates',
  },
};
